import "@fontsource-variable/inter";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { startPwa } from "./features/pwa/pwa";
import { initTheme } from "./features/theme/theme";
import { reloadOnStaleBuild } from "./lib/stale-build";

initTheme();
reloadOnStaleBuild();
// Before anything renders: the browser's install prompt fires early.
startPwa();

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
